import { createRuntimeFn } from '@vanilla-extract/recipes/createRuntimeFn';

var tooltipContent = createRuntimeFn({defaultClassName:'fx_2d2fb1e5_ru7qad3',variantClassNames:{prefersReducedMotion:{noPreference:'fx_2d2fb1e5_ru7qad4',reduce:'fx_2d2fb1e5_ru7qad5'}},defaultVariants:{prefersReducedMotion:'noPreference'},compoundVariants:[]});
var tooltipContentBackground = 'var(--fx_2d2fb1e5_ru7qad2)';

export { tooltipContent, tooltipContentBackground };
//# sourceMappingURL=content.vanilla.mjs.map
